export interface IBaseGuidDTO {

    Id: string;
    DataCriacao: string;
    DataAlteracao: string;
    DataDesativacao: string;
    Ativo: boolean;

}

export class BaseDTO {

    fromObject(input: any) {
        Object.assign(this, input);

        return this;
    }
}

export class BaseGuidDTO extends BaseDTO implements IBaseGuidDTO {

    Id: string;
    DataCriacao: string;
    DataAlteracao: string;
    DataDesativacao: string;
    Ativo: boolean;

    constructor(data: any = {}) {
        super();
        this.Id = data.Id;
        this.DataCriacao = data.DataCriacao;
        this.DataAlteracao = data.DataAlteracao;
        this.DataDesativacao = data.DataDesativacao;
        this.Ativo = data.Ativo;
    }

}